// Inline SVG QR renderer — no <img>, no network. Coalesces horizontal runs of dark
// modules into single rects to keep the DOM small; adds a 4-module quiet zone.
import { useMemo } from 'react';
import { encodeQr } from '../../lib/qr';

const QUIET_ZONE = 4;

export function QrCode({
  value,
  label = 'QR code',
  className,
}: {
  value: string;
  label?: string;
  className?: string;
}) {
  const { size, runs } = useMemo(() => {
    const matrix = encodeQr(value);
    const modules = matrix.length;
    const boxSize = modules + QUIET_ZONE * 2;

    const rects: Array<{ x: number; y: number; w: number }> = [];
    for (let r = 0; r < modules; r++) {
      let runStart = -1;
      for (let c = 0; c <= modules; c++) {
        const dark = c < modules && matrix[r][c];
        if (dark && runStart < 0) {
          runStart = c;
        } else if (!dark && runStart >= 0) {
          rects.push({ x: runStart + QUIET_ZONE, y: r + QUIET_ZONE, w: c - runStart });
          runStart = -1;
        }
      }
    }
    return { size: boxSize, runs: rects };
  }, [value]);

  return (
    <svg
      role="img"
      aria-label={label}
      className={className}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
    >
      <rect x={0} y={0} width={size} height={size} fill="#ffffff" />
      {runs.map((run, i) => (
        <rect key={i} x={run.x} y={run.y} width={run.w} height={1} fill="#000000" />
      ))}
    </svg>
  );
}
